import { Operator, Reference } from '@yleisradio/areena-types';

const itemIdRegex = /1-\d+/;

export const services = [
  'yle-tv1',
  'yle-tv2',
  'yle-teema-fem',
  'yle-areena',
  'yle-radio-1',
  'ylex',
  'yle-radio-suomi-helsinki',
  'yle-radio-suomi-turku',
  'yle-radio-suomi-pori',
  'yle-radio-suomi-jyvaskyla',
  'yle-radio-suomi-tampere',
  'yle-radio-suomi-lahti',
  'yle-radio-suomi-hameenlinna',
  'yle-radio-suomi-lappeenranta',
  'yle-radio-suomi-kotka',
  'yle-radio-suomi-kuopio',
  'yle-radio-suomi-mikkeli',
  'yle-radio-suomi-joensuu',
  'yle-radio-suomi-seinajoki',
  'yle-radio-suomi-vaasa',
  'yle-radio-suomi-kokkola',
  'yle-radio-suomi-oulu',
  'yle-radio-suomi-kajaani',
  'yle-radio-suomi-rovaniemi',
  'yle-radio-suomi-kemi',
  'radio-vega-osterbotten',
  'radio-vega-aboland',
  'radio-vega-vastnyland',
  'radio-vega-huvudstadsregionen',
  'radio-vega-ostnyland',
  'yle-puhe',
  'yle-radio-vega',
  'yle-x3m',
  'yle-klassinen',
  'yle-sami-radio',
  'areena-audio-live',
];
const serviceRegex = /^(yle-tv1|yle-tv2|yle-teema-fem|yle-areena)-/;

export const getItemIdFromFavoriteReference = (
  reference: Reference | undefined
): string | undefined => {
  if (reference) {
    const uri = reference?.destination?.uri;
    const itemId = uri && itemIdRegex.exec(uri)?.[0];
    return itemId;
  }
};

export const getItemIdFromFavoriteOperator = (
  operator: Operator | null | undefined
): string | undefined => {
  if (operator) {
    const uri = operator.destination?.uri;

    return uri && itemIdRegex.exec(uri)?.[0];
  }
};

export const getItemIdFromOperator = (
  operator: Operator | null | undefined
): string | undefined => {
  if (operator) {
    const uri = operator.operation?.uri;
    const itemId = uri && itemIdRegex.exec(uri)?.[0];
    return itemId;
  }
};

export const isItemId = (itemId: string): boolean => /^1-\d+$/.test(itemId);

export const isPrefixWithServiceId = (itemId: string) => {
  const serviceId = serviceRegex.exec(itemId)?.[1];
  return isServiceId(serviceId);
};

export const isServiceId = (itemId?: string): boolean =>
  itemId ? services.includes(itemId) : false;

export const isSimulcastView = (itemId: string): boolean =>
  isServiceId(itemId) || isPrefixWithServiceId(itemId);
